module.exports = __webpack_public_path__ + "img/ascend_gold40.d1e7fcab.png";